import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_filter",
  "use": "icon_filter-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon_filter\"><path d=\"M28.082 2.664H3.918c-1.11 0-1.67 1.347-.884 2.134l9.632 9.634v10.732c0 .408.2.79.534 1.024l4.166 2.916c.822.575 1.967-.008 1.967-1.024V14.432l9.633-9.634c.785-.785.229-2.134-.884-2.134z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol